import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableResult } from '../../../../shared/services/global/global.models';
import { Role } from '../roles/roles.models';
import { GetAllCompaniesResponse, User, UsersListItemViewModel } from './users.models';

@Injectable()
export class UsersService
{
	// constructor
	constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
	{

	}

	// get filtered
	public getFiltered(filters): Observable<DataTableResult<UsersListItemViewModel>>
	{
		return this.http.post<DataTableResult<UsersListItemViewModel>>(`${this.baseUrl}api/admin/users/users/getList`, filters);
	}

	// get single
	public getSingle(id: string): Observable<User>
	{
		return this.http.get<User>(`${this.baseUrl}api/admin/users/users/getSingle/${id !== null ? id : ""}`);
	}

	// insert/update
	public insertUpdate(user: User): Observable<User>
	{
		return this.http.post<User>(`${this.baseUrl}api/admin/users/users/insertUpdate`, user);
	}

	// delete
	public delete(id: string): Observable<User>
	{
		return this.http.delete<User>(`${this.baseUrl}api/admin/users/users/delete/${id}`);
	}

	// export
	public export()
	{
		return this.http.get(`${this.baseUrl}api/admin/users/users/export`, { responseType: 'blob' });
	}

	// get all roles
	public getAllRoles(): Observable<Array<Role>>
	{
		return this.http.get<Array<Role>>(`${this.baseUrl}api/admin/users/users/getAllRoles`);
	}

	// get all companies
	public getAllCompanies(): Observable<Array<GetAllCompaniesResponse>>
	{
		return this.http.get<Array<GetAllCompaniesResponse>>(`${this.baseUrl}api/admin/users/users/getAllCompanies`);
	}
}